<template>
<div>
  <div class="wistia_embed wistia_async_khr8xfrz9o">
    &nbsp;
  </div>

  <div
    id="answer_ignore"
    class="tbk-vid-embed"
  >
    <a
      id="answer"
      class="embedded_video"
      href="#wistia_dmju9fk6wk?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="ignore"
      class="embedded_video"
      href="#wistia_nqqthey6cu?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>

  <div
    id="continue_hang_up"
    class="tbk-vid-embed"
  >
    <a
      id="continue"
      class="embedded_video"
      href="#wistia_d33o6qb9si?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="hang_up"
      class="embedded_video"
      href="#wistia_xztcnqrs7c?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>

  <div
    id="wire_money_hang_up"
    class="tbk-vid-embed"
  >
    <a
      id="wire_money"
      class="embedded_video"
      href="#wistia_a11fh57xii?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="hang_up"
      class="embedded_video"
      href="#wistia_xztcnqrs7c?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>

  <div
    id="family_emergency"
    class="tbk-vid-embed"
  >
    <a
      id="intro"
      class="embedded_video"
      href="#wistia_khr8xfrz9o?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('khr', 4, this.showAnswerIgnore)
    this.tbk.loadCrossTime('dmj', 15, this.showContinueHangUp)
    this.tbk.loadCrossTime('d33', 28, this.showWireMoneyHangUp)
    this.tbk.loadCrossTime('a11', 53, this.showFamilyEmergency)
    this.tbk.loadCrossTime('xzt', 18, this.showFamilyEmergency)
    this.tbk.loadCrossTime('nqq', 17, this.showFamilyEmergency)

    if (this.tbk.isMobile()) {
      _wq.push({
        khr: this.tbk.autoPlay,
        dmj: this.tbk.autoPlay,
        d33: this.tbk.autoPlay,
        a11: this.tbk.autoPlay,
        xzt: this.tbk.autoPlay,
        nqq: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showAnswerIgnore() {
      $('#answer_ignore').show()
      this.tbk.hideMobileControls()
    },

    showContinueHangUp() {
      $('#continue_hang_up').show()
      this.tbk.hideMobileControls()
    },

    showWireMoneyHangUp() {
      $('#wire_money_hang_up').show()
      this.tbk.hideMobileControls()
    },

    showFamilyEmergency() {
      $('#family_emergency').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang='sass'>
#answer_ignore,
#continue_hang_up,
#wire_money_hang_up,
#family_emergency
  display: none
  a
    text-decoration: none

#answer
  position: absolute
  top: calc(100% * (17 / 360))
  left: calc(100% * (17 / 640))
  width: calc(100% * (285 / 640))
  height: calc(100% * (291 / 360))
#ignore
  position: absolute
  top: calc(100% * (17 / 360))
  left: calc(100% * (337 / 640))
  width: calc(100% * (285 / 640))
  height: calc(100% * (291 / 360))
#continue
  position: absolute
  top: calc(100% * (17 / 360))
  left: calc(100% * (17 / 640))
  width: calc(100% * (285 / 640))
  height: calc(100% * (291 / 360))
#hang_up
  position: absolute
  top: calc(100% * (17 / 360))
  left: calc(100% * (337 / 640))
  width: calc(100% * (285 / 640))
  height: calc(100% * (291 / 360))
#wire_money
  position: absolute
  top: calc(100% * (17 / 360))
  left: calc(100% * (17 / 640))
  width: calc(100% * (285 / 640))
  height: calc(100% * (291 / 360))
#intro
  position: absolute
  top: calc(100% * (17 / 360))
  left: calc(100% * (176 / 640))
  width: calc(100% * (285 / 640))
  height: calc(100% * (291 / 360))
</style>
